
/**
 * Request header names used by the server.
 * @type {Object}
 */
const REQUEST_HEADERS = {
    SESSION_TOKEN: 'x-session-token',
    BEARER_TOKEN: 'authorization',
}

export default REQUEST_HEADERS
